//import _, { initial } from "lodash";
import { mapState } from "vuex";

//import { eventBus } from "./../../../../main";

var width = 1;
var bytesPerPixel = 4;
var blankImage = new Uint8Array(width * width * bytesPerPixel);
for (var x = 0; x < width; x++) {
  for (var y = 0; y < width; y++) {
    var offset = (y * width + x) * bytesPerPixel;
    blankImage[offset + 0] = 1; // red
    blankImage[offset + 1] = 1; // green
    blankImage[offset + 2] = 1; // blue
    blankImage[offset + 3] = 0; // alpha
  }
}

export default {
  data: () => ({}),

  computed: {
    ...mapState({
      iconcategory: state => state.mapsetupdate.iconcategory
    }),
    imageList() {
      let imageList = this.iconcategory.map(row => {
        let { id, name, catimage } = row;
        let { very_small_marker } = catimage;

        return {
          id,
          name,
          src: very_small_marker,
          height: 100,
          width: 100
        };
      });

      return imageList;
    }
  },

  methods: {
    loadImage() {},
    async initializeMarkerIcons() {
      console.log("initializeMarkerIcons");
      console.log(this.iconcategory);
      console.log(this.imageList);

      this.imageList.forEach(markerImage => {
        let { id } = markerImage;

        this.map.addImage(id, {
          width: 1,
          height: 1,
          data: blankImage
        });
      });

      this.imageList.forEach(markerImage => {
        let { id, src } = markerImage;

        this.map.loadImage(`${src}`, async (error, image) => {
          if (error) {
            console.log("error");
          } else {
            this.map.removeImage(id);
            this.map.addImage(id, image, { pixelRatio: 2 });
            console.log("image loaded!!!");
          }
        });
      });
    }
  },
  destroyed() {},
  mounted() {},
  watch: {}
};
